import { useNavigate } from "react-router-dom";

function NavButton({text, width, link, img, hoverImg, height, transparentText}){
    const navigate = useNavigate();

    return(
        <div className="NavButton" style={{width: width, height: height, backgroundImage: !hoverImg ? `url(${img})` : `url(${hoverImg})`}} onClick={() => navigate(link)}>
            <p className={transparentText ? "navbutton-text-transparent" : ""} style={{maxWidth: '60%'}}>{text}</p>
        </div>
    );
}
export default NavButton;